import { render } from "./Project2View.vue?vue&type=template&id=63f780ff&scoped=true"
import script from "./Project2View.vue?vue&type=script&lang=js"
export * from "./Project2View.vue?vue&type=script&lang=js"

import "./Project2View.vue?vue&type=style&index=0&id=63f780ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f780ff"]])

export default __exports__